const formatThreshold = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number.toExponential(4) : "-";
};

const formatMetric = (value, digits = 2) => {
    const number = Number(value);
    return Number.isFinite(number) ? number.toFixed(digits) : "-";
};

const ThresholdSuggestionTable = ({ suggestion, onClose }) => {
    if (!suggestion?.candidates?.length) return null;

    const suggestedRange = suggestion.suggested_range;

    return (
        <section className="threshold-suggestion-panel">
            <div className="threshold-suggestion-header">
                <div>
                    <h3>Threshold suggestions</h3>
                    <p>
                        Recommended value: <strong>{formatThreshold(suggestion.suggested_treshold)}</strong>
                    </p>
                    {suggestedRange && (
                        <p>
                            Suggested range: {formatThreshold(suggestedRange.from)} – {formatThreshold(suggestedRange.to)}
                        </p>
                    )}
                </div>
                <button
                    type="button"
                    className="threshold-suggestion-close"
                    onClick={onClose}
                    aria-label="Close threshold suggestions"
                >
                    ×
                </button>
            </div>

            <p className="threshold-suggestion-description">
                The table is advisory only. Copy the selected value into the treshold field and save the parameters yourself.
            </p>

            <div className="threshold-suggestion-table-wrapper">
                <table className="threshold-suggestion-table">
                    <thead>
                        <tr>
                            <th>Suggestion</th>
                            <th>treshold</th>
                            <th>Percentile</th>
                            <th>Sections</th>
                            <th>Data used</th>
                            <th>Median CV</th>
                            <th>90% CV</th>
                            <th>90% drift</th>
                            <th>Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        {suggestion.candidates.map((candidate, index) => (
                            <tr
                                key={`${candidate.treshold}-${index}`}
                                className={candidate.recommended ? "threshold-suggestion-recommended" : ""}
                            >
                                <td>
                                    {candidate.recommended && <span className="threshold-suggestion-badge">Recommended</span>}
                                    {candidate.is_current && <span className="threshold-current-badge">Current</span>}
                                    {!candidate.recommended && !candidate.is_current && "Candidate"}
                                </td>
                                <td className="threshold-value-cell">{formatThreshold(candidate.treshold)}</td>
                                <td>{candidate.percentile == null ? "-" : `${candidate.percentile}%`}</td>
                                <td>{candidate.stable_sections_count}</td>
                                <td>{formatMetric(candidate.usable_samples_percent)}%</td>
                                <td>{formatMetric(candidate.median_cv_percent, 3)}%</td>
                                <td>{formatMetric(candidate.p90_cv_percent, 3)}%</td>
                                <td>{formatMetric(candidate.p90_drift_percent, 3)}%</td>
                                <td>{formatMetric(candidate.score, 1)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <p className="threshold-suggestion-method">
                {suggestion.details?.method}
            </p>
        </section>
    );
};

export default ThresholdSuggestionTable;
